import type { IModuleDefinition } from '@platform/core/types';

/**
 * Тип записів, підсвічений на сторінці «Записи й форми» (прототип v4 cmFocus): «Статуси» — довідник статусів основного типу
 * (statusCatalogue), «Типи» — довідник типів (ключ на «_type»). Без такого довідника — нічого. Чиста функція.
 */
export function recordsFocusOf(module: IModuleDefinition, item: string): string | undefined {
  const main = module.recordTypes.find((r) => r.main);
  if (item === 'statuses') return main?.statusCatalogue ?? module.recordTypes.find((r) => r.kind === 'catalogue' && /status$/i.test(r.key))?.key;
  if (item === 'types') return module.recordTypes.find((r) => r.kind === 'catalogue' && /type$/i.test(r.key))?.key;
  return undefined;
}
